import React from "react";

const FormLabelFieldPreview = props => {
  const {number, label, className} = props;

  const classes = `fs-6 text-secondary ${className}`;

  return (
    <div className={classes}>
      {number && <span className="fw-bold me-2">{number}.</span>}
      {label}
    </div>
  );
};

export default FormLabelFieldPreview;
